import { scoreBand, type ScoreBand } from '../shared/deals';

// A scored deal gets a printed verdict, the way a review carries a rating and
// the word for it. Two reasons it isn't just the number: the band is the part
// you act on, and colour alone must never be what tells you which band it is.
const BAND_BOX: Record<ScoreBand, string> = {
  act: 'bg-accent text-paper border-accent',
  solid: 'text-ochre border-ochre',
  marginal: 'text-ink border-rule-strong',
  skip: 'text-ink-faint border-rule',
};

const BAND_WORD: Record<ScoreBand, string> = {
  act: 'text-accent',
  solid: 'text-ochre',
  marginal: 'text-ink-faint',
  skip: 'text-ink-faint',
};

const BAND_LABEL: Record<ScoreBand, string> = {
  act: 'Act now',
  solid: 'Solid',
  marginal: 'Marginal',
  skip: 'Skip',
};

export function ScoreBadge({ score }: { score: number | null }) {
  const band = scoreBand(score);
  const label = score == null ? 'Unscored' : BAND_LABEL[band];

  return (
    <span
      className="flex shrink-0 flex-col items-end gap-1"
      title={score == null ? 'Not scored yet' : `${label} — ${score} of 100`}
    >
      <span
        className={`inline-flex min-w-9 items-center justify-center border px-1.5 py-0.5 font-mono text-sm leading-none font-semibold tabular ${BAND_BOX[band]}`}
      >
        {score ?? '—'}
      </span>
      <span
        className={`font-mono text-[0.625rem] leading-none tracking-[0.12em] uppercase ${BAND_WORD[band]}`}
      >
        {label}
      </span>
    </span>
  );
}
